import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Observable, Subscription} from 'rxjs';
import {Patient} from '../../models/patient';
import {
    ConfirmValidParentMatcher,
    CustomValidatorsModule,
    errorMessages,
    OapErrorMessages,
    OapStandarErrorStateMatcher,
    regExps
} from '../../modules/custom-validators/custom-validators.module';
import {LoaderService} from '../../services/loader.service';
import {TrackingService} from '../../services/tracking.service';
import {MessageService} from '../../services/message.service';
import {CompteService} from '../../services/compte.service';
import {AlertService} from '../../services/alert.service';
import {StorageService} from '../../services/storage.service';
import {first, tap} from 'rxjs/operators';
import {PatientService} from '../../services/patient.service';
import {DomSanitizer} from '@angular/platform-browser';
import {MatIconRegistry} from '@angular/material';
import {CurrentPatientService} from '../../services/current-patient.service';

@Component({
  selector: 'oap-login-data',
  templateUrl: './login-data.component.html',
  styleUrls: ['./login-data.component.scss']
})
export class LoginDataComponent implements OnInit, OnDestroy {
    editMobileForm: FormGroup;
    editEmailForm: FormGroup;
    editPasswordForm: FormGroup;
    checkPasswordForm: FormGroup;
    editNewsletterForm: FormGroup;

    submitMobileLoading = false;
    submitEmailLoading = false;
    submitPasswordLoading = false;
    submitNewsletterLoading = false;
    showChangePassword = false;

    passwordSubmitted = false;
    emailSubmitted = false;
    inputTypePassword = 'password';
    inputTypeCheckPassword = 'password';
    tooltip_password = 'Voir le mot de passe';
    inputTypeConfirmPassword = 'password';
    tooltip_confirm_password = 'Voir le mot de passe';
    matcher = new OapStandarErrorStateMatcher();
    confirmValidParentMatcher = new ConfirmValidParentMatcher();

    patientModel: Observable<Patient>;
    errors = errorMessages;
    validation_messages = OapErrorMessages;
    public subscription: Subscription;
    patientId: number;
    firstPatientId: number;
    isParent: boolean;
    currentPatient = null;
    currentCompte = null;
    public maskTel = [/\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/];
    public disabled: boolean;
    public showMobileCodeForm = false;
    public showEmailCodeForm = false;

    public getcodeerrorMobile ;
    public getcodeMobile = {} ;
    public codevalideMobile = true;
    public getcodeerrorEmail ;
    public getcodeEmail = {} ;
    public codevalideEmail = true;
  constructor(private messageService: MessageService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService,
              private alertService: AlertService,
              private tracking: TrackingService,
              private storageService: StorageService,
              private compteService: CompteService,
              private iconRegistry: MatIconRegistry,
              private sanitizer: DomSanitizer,
              private patientService: PatientService,
              private currentPatientService: CurrentPatientService) {
      iconRegistry.addSvgIcon('eye', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-remove_red_eye-24px.svg'));
  }

  ngOnInit() {
      this.loaderService.showLoader();
      this.alertService.clear();
      this.messageService.sendMessage('page-login-data');
      this.currentPatientService.putFirstPatientAsCurrent();
      this.infoPatient();
      this.subscription = this.storageService.watchStorage().subscribe((data: string) => {
          this.infoPatient();
      });
      this.tracking.DataLayer('/app/login-data', 'Rubrique', 'Mon profil','');
  }

    ngOnDestroy() {
        if (this.subscription !== undefined) {
            this.subscription.unsubscribe();
        }
    }

    private infoPatient() {
        this.patientId = parseInt(JSON.parse(localStorage.getItem('patientId')));
        this.firstPatientId = parseInt(JSON.parse(localStorage.getItem('firstPatientId')));
        this.isParent = (this.patientId === this.firstPatientId);
        this.disabled = !this.isParent;

        this.editMobileForm = this.formBuilder.group({
            mobile: [{value: '', disabled: this.disabled}, [CustomValidatorsModule.maskMinValidator(10),
                Validators.required]],
            code: [''],
        });

        this.editEmailForm = this.formBuilder.group({
            matchingEmails: this.formBuilder.group({
                email: ['', [Validators.required,
                    Validators.minLength(5),
                    Validators.maxLength(256),
                    Validators.email]],
                emailConf: ['', Validators.required],
            }, {
                validator: (formGroup: FormGroup) => {
                    const ret = CustomValidatorsModule.areEqual(formGroup);
                    return ret;
                }
            }),
            emailCode: ['']
        });

        this.checkPasswordForm = this.formBuilder.group({
            checkPassword : this.formBuilder.group({
                password: ['', [Validators.required,
                    Validators.maxLength(100)
                ]]              
            })
        });

        this.editPasswordForm = this.formBuilder.group({
            matchingPassword : this.formBuilder.group({
                password: ['', [Validators.required,
                    Validators.pattern(regExps.password),
                    Validators.maxLength(100)
                ]],
                confirmPassword: ['', Validators.required]
            }, {
                validator: (formGroup: FormGroup) => {
                    const ret =  CustomValidatorsModule.areEqual(formGroup);
                    return ret;
                }
            })
        });

        this.editNewsletterForm = this.formBuilder.group({
            newsletter: [''],
        });

        this.patientModel = this.patientService.getPatient(this.patientId).pipe(
            tap(patient => {
                if (this.currentPatient !== patient) {
                    this.currentPatient = patient;
                }
                this.compteService.getById(patient.compteKey).subscribe((compte: any) => {
                    if (this.currentCompte !== compte) {
                        this.currentCompte = compte;
                    }
                    this.editMobileForm.patchValue(
                        {
                            mobile: compte.mobile
                        });
                    this.editNewsletterForm.patchValue(
                        {
                            newsletter: compte.accepteNewsletters
                        });
                });
                    this.loaderService.hideLoader();
                }
            )
        );

    }

    public onMobileFormSubmit(form: FormGroup) {
        if (this.editMobileForm.invalid) {
            return;
        } else {
            const mobileWithoutSpaces = (form.controls.mobile.value).replace(/\s/g, '');
            this.compteService.askUpdateMobile(this.currentPatient.compteKey, mobileWithoutSpaces)
              .subscribe(
                (res: any) => {
                    if (res.sent === true) {
                        this.alertService.success('Code de vérification envoyé par SMS', true);
                        this.showMobileCodeForm = true;

                        this.editMobileForm = this.formBuilder.group({
                            mobile: [{value: form.controls.mobile.value, disabled: this.disabled}, [CustomValidatorsModule.maskMinValidator(10),
                                Validators.required]],
                            code: ['', Validators.required],
                        });
            
                    } else {
                        this.alertService.error(res.message, true);
                    }
                },
                error => {
                    this.alertService.error(error, true);
                });
            
        }
    }

    public onMobileCodeSubmit(form: FormGroup) {
        if (this.editMobileForm.invalid) {
            return;
        } else {
            const codeOtp = form.controls.code.value;
            if (codeOtp === '') {
                this.alertService.error('Veuillez saisir le code reçu', true);
            } else {
                const mobileWithoutSpaces = (form.controls.mobile.value).replace(/\s/g, '');
                this.compteService.validateUpdateMobile(JSON.parse(localStorage.getItem('patients'))[0].compteKey, codeOtp, mobileWithoutSpaces)
                    .subscribe(
                        (res: any) => {
                                this.infoPatient();
                                this.alertService.success('Numéro de téléphone changé avec succès', true);
                                 },
                        error => {
                            this.alertService.error('Code invalide', true);
                        });
            }
        }
    }

    public toggleViewPassword() {
        if (this.inputTypePassword === 'password') {
            this.inputTypePassword = 'text';
            this.tooltip_password = 'Cacher le mot de passe';
        } else {
            this.inputTypePassword = 'password';
            this.tooltip_password = 'Voir le mot de passe';
        }
    }

    public toggleViewCheckPassword() {
        if (this.inputTypeCheckPassword === 'password') {
            this.inputTypeCheckPassword = 'text';
            this.tooltip_password = 'Cacher le mot de passe';
        } else {
            this.inputTypeCheckPassword = 'password';
            this.tooltip_password = 'Voir le mot de passe';
        }
    }

    public toggleViewConfirmPassword() {
        if (this.inputTypeConfirmPassword === 'password') {
            this.inputTypeConfirmPassword = 'text';
            this.tooltip_confirm_password = 'Cacher le mot de passe';
        } else {
            this.inputTypeConfirmPassword = 'password';
            this.tooltip_confirm_password = 'Voir le mot de passe';
        }
    }

    public onEmailFormSubmit(form: FormGroup) {
        this.emailSubmitted = true;
        if (this.editEmailForm.invalid) {
            return;
        } else {
            if (this.currentCompte.email === form.controls.matchingEmails.value.email) {
                this.alertService.error('Veuillez renseigner une adresse différente de celle utilisée actuellement', true);
            } else if (form.controls.matchingEmails.value.email !== form.controls.matchingEmails.value.emailConf) {
                this.alertService.error('Veuillez renseigner des adresses identiques', true);
            } else {
                this.compteService.askUpdateEmail(this.currentPatient.compteKey, form.controls.matchingEmails.value.email)
                .subscribe(
                    (res: any) => {
                        if (res.sent === true ) {
                            this.alertService.success('Code de vérification envoyé par Email', true);

                            this.editEmailForm = this.formBuilder.group({
                                matchingEmails: this.formBuilder.group({
                                    email: [form.controls.matchingEmails.value.email, [Validators.required,
                                        Validators.minLength(5),
                                        Validators.maxLength(256),
                                        Validators.email]],
                                    emailConf: [form.controls.matchingEmails.value.emailConf, Validators.required]
                                }, {
                                    validator: (formGroup: FormGroup) => {
                                        const ret = CustomValidatorsModule.areEqual(formGroup);
                                        return ret;
                                    }
                                }),
                                emailCode: ['', Validators.required]
                            });
                            this.showEmailCodeForm = true;

                        } else {
                            this.alertService.error(res.message, true);
                        }
                    },
                    error => {
                        this.alertService.error(error, true);
                    });

            }
        }
    }

    public onEmailCodeSubmit(form: FormGroup) {
        if (this.editEmailForm.invalid) {
            return;
        } else {
            if (form.controls.emailCode.value === '') {
                this.alertService.error('Veuillez saisir le code reçu', true);
            } else {
                this.compteService.validateUpdateEmail(JSON.parse(localStorage.getItem('patients'))[0].compteKey, form.controls.emailCode.value, form.controls.matchingEmails.value.email)
                    .pipe(first())
                    .subscribe(
                        result => {
                            const currentUser = JSON.parse(localStorage.getItem('currentUser'));
                            currentUser.refreshToken = result.tokensUpdated.refreshToken;
                            currentUser.token = result.tokensUpdated.token;
                            localStorage.setItem('currentUser', JSON.stringify(currentUser));
                            this.infoPatient();
                            this.showEmailCodeForm = false;
                            this.alertService.success('Adresse email changé avec succès', true);
                        },
                        error => {
                            this.alertService.error('Code invalide', true);
                        }
                    );
            }
        }
    }

    public onCheckPasswordFormSubmit(form: FormGroup) {
        this.passwordSubmitted = true;
        if (this.checkPasswordForm.invalid) {
            return;
        }

        this.compteService.checkPassword(form.controls.checkPassword.value.password, this.currentPatient.compteKey)
            .pipe(first())
            .subscribe(
                data => {
                   if (data.valid === true) {
                        this.showChangePassword = true;
                        this.alertService.clear();  
                      } else {
                        this.alertService.error("Le mot de passe saisi ne cosrrespond pas à votre mot de passe actuel.", false);  
                      }
                },
                error => {
                    this.alertService.error(error, false);
                });
    }

    public onPasswordFormSubmit(form: FormGroup) {
        this.passwordSubmitted = true;
        if (this.editPasswordForm.invalid) {
            return;
        }

        if (form.controls.matchingPassword.value.password !== form.controls.matchingPassword.value.confirmPassword) {
            this.alertService.error('Veuillez renseigner des mots de passes identiques', true);
        } else {
            this.compteService.updatePassword(form.controls.matchingPassword.value.password, this.currentPatient.compteKey)
                .pipe(first())
                .subscribe(
                    data => {
                        this.alertService.success('Mot de passe mis à jour avec succès', true);
                    },
                    error => {
                        this.alertService.error(error, false);
                    });

            this.tracking.pushDataLayer('Mot de passe', 'Click', 'Validation');
        }
   }

    public onNewsletterFormSubmit(form: FormGroup) {
        if (this.editNewsletterForm.invalid) {
            return;
        } else {
            this.compteService.updateNewsletter(form.controls.newsletter.value, this.currentPatient.compteKey)
                .pipe(first())
                .subscribe(
                    obsData => {
                        this.alertService.success('Modifications enregistrées', true);
                        this.submitNewsletterLoading = false;
                    },
                    error => {
                        this.alertService.error(error);
                        this.submitNewsletterLoading = false;
                    });
        }
    }

}
